<template lang="pug">
	.create-new-campaign(v-if="showed")
		.card
			.card-header Create New Campaign
			.card-body
				.property
					.property-name Campaign Name
					.property-value
						input.form-control(v-model="campaignName" ref="campaignNameInput")
				.property
					.property-name Campaign Order
					.property-value
						.dropdown(ref="dropdownParent")
							button.btn.btn-primary.dropdown-toggle(type="button" data-toggle="dropdown" @click="toggleSelect" style="width: 100%") {{campaignOrder || 'Order'}}
								span.caret
							.dropdown-bg(@click="toggleSelect")
							ul.dropdown-menu(ref="dropdownMenu")
								input.form-control#order-input(type="text" placeholder="Filter.." autocomplete="off" @keyup="filterOrders($event.target.value)")
								div.order-name(v-for="order in orders")
									a(:href="'#'" @click="selectOrder(order)") {{order.name}}
				.error-message {{errorMessage}}
			.card-footer
				button.btn.btn-cancel(@click="hide") Cancel
				button.btn.btn-primary.btn-confirm(type="submit" @click="createNewCampaign") Create Campaign

</template>

<script>

	import Screen from "@/mixins/screen";
	import {Server} from "@/services/Server";

	export default {
		name: 'CreateNewCampaign',
		mixins: [Screen],
		screen: {
			updateOn: [],
			events: {
				'New Campaign Created': function (error = false, campaign) {
					if (!error) {
						this.hide();
						if (campaign) Broadcast.call("Show ShowCampaign", [campaign]);
						return;
					}
					this.errorMessage = error;
				}
			}
		},
		data() {

			this.Server = Server;
			this.ordersValues = [];

			return {
				campaignName: '',
				campaignOrder: '',
				errorMessage: '',
				orders: {}
			}
		},
		methods: {
			collectData() {
				this.campaignName = '';
				this.campaignOrder = '';
				this.campaignOrderId = 0;
				this.errorMessage = '';

				this.orders = Object.values(Order.Orders);

				this.ordersValues = this.orders.map(order => {
					return {
						title: order.name,
						value: order.name
					}
				});
			},

			filterOrders(value) {
				this.orders = Object.values(Order.Orders).slice().filter(order => order.name.toLowerCase().includes(value.toLowerCase()));
			},

			selectOrder(order) {
				this.campaignOrder = order.name;
				this.campaignOrderId = order.id;
				this.toggleSelect();
			},

			toggleSelect() {
				this.$refs.dropdownParent.classList.toggle('open');

				this.$nextTick(() => {
					const dropdownMenu = this.$refs.dropdownMenu;
					const dropdownMenuHeight = dropdownMenu.offsetHeight;
					const dropDownMenuTop = dropdownMenu.getBoundingClientRect().top;
					const desiredDropdownMenuHeight = window.innerHeight - dropDownMenuTop - 50;
					dropdownMenu.style.maxHeight = desiredDropdownMenuHeight + 'px';
					dropdownMenu.style.maxHeight = 150 + 'px';
					dropdownMenu.style.overflow = 'hidden scroll';
				});

			},

			createNewCampaign() {
				if (!this.campaignName) {
					this.errorMessage = 'Please provide valid campaign name';
					return;
				}
				if (!this.campaignOrder || !this.campaignOrderId) {
					this.errorMessage = 'Please provide valid order for campaign';
					return;
				}

				Server.sendToSocket({
					CreateNewCampaign: {
						name: this.campaignName,
						orderId: this.campaignOrderId
					}
				});
			}
		}
	}

</script>

<style lang="sass">

	.create-new-campaign
		position: absolute
		z-index: 2000
		top: 0
		left: 0
		bottom: 0
		right: 0
		display: flex
		justify-content: center
		align-items: center


		.dropdown

			button.dropdown-toggle
				border: unset
				border-bottom: 2px solid #7d7e88
				border-radius: 0
				background: unset
				&:focus
					box-shadow: unset

				>span
					padding-left: 5px

			> .dropdown-bg
				display: none
				background-color: unset
			&.open > .dropdown-bg
				display: block
				position: fixed
				top: 0
				left: 0
				bottom: 0
				right: 0

			.dropdown-menu
				background: rgb(201,187,255)
				background: linear-gradient(-117deg, rgba(201,187,255,1) 0%, rgba(201,187,255,1) 100%)
				overflow: hidden scroll

				input
					background-color: #3a3c49
					border: unset
					border-radius: 0

				>.order-name
					padding: 2px 0 2px 0

				>.order-name:hover
					background-color: #857eae

				a
					color: #3a3b4a

				>input::placeholder
					color: lightgray

				&::-webkit-scrollbar
					appearance: none
					width: 5px
				&::-webkit-scrollbar-thumb
					background-color: #343434
					border-radius: 15px

		>.card
			width: 400px
			background-color: #3a3b4a
			border-radius: 15px

			>.card-header
				background-color: #3a3b4a
				border-radius: 15px 15px 0 0

			>.card-footer
				display: flex
				flex-direction: row
				justify-content: space-between
				border-radius: 0 0 15px 15px
				background-color: #3a3b4a

				>.btn-cancel
					background-color: #3a3b4a
					color: #aaa1f5
					border-color: #857dcc
					border-radius: 10px
				>.btn-confirm
					background-color: #aaa1f5
					border: unset
					color: black
					border-radius: 10px

			>.card-body
				display: flex
				flex-direction: column
				gap: 0.5em

				>.error-message
					font-size: 95%
					color: red
				>.property
					display: flex
					flex-direction: row
					align-items: center
					gap: 15px

					>.property-name
						width: 160px
						color: #aaa1f5

					>.property-value
						flex: 1

						>input
							height: 35px
							border-bottom: 2px solid #7d7e88
							border-radius: 0
							background: unset
							&:focus
								box-shadow: unset

						>input.checkbox
							width: 35px
							height: 35px




</style>
